"use client";

import Image from "next/image";
import { styled } from "@mui/material/styles";

const ResponsiveImage = styled(Image)(({ theme }) => ({
  width: "100%",
  height: "250px", // 🖥️ Altura por defecto en desktop
  objectFit: "contain",

  [theme.breakpoints.down("sm")]: {
    height: "100px", // 📱 Altura más pequeña en pantallas móviles
  },
}));

export default ResponsiveImage;
